"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuntimeHelpersTemplate = getRuntimeHelpersTemplate;
const VMConstants_1 = require("../../../constants/VMConstants");
function getRuntimeHelpersTemplate() {
    return `
            // Helper: Collect arguments from stack with spread support
            // Used by CALL, CALL_METHOD, NEW, SUPER_CALL opcodes
            function collectArgs(stack, argCount) {
                let args = [];
                for (let i = 0; i < argCount; i++) {
                    let val = stack.pop();
                    if (val && typeof val === 'object' && val.__spread__ === true) {
                        let spreadArr = val.value;
                        if (Array.isArray(spreadArr)) {
                            for (let j = spreadArr.length - 1; j >= 0; j--) {
                                args.push(spreadArr[j]);
                            }
                        }
                    } else {
                        args.push(val);
                    }
                }
                args.reverse();
                return args;
            }

            // Debug protection: Timing-based anti-debug check
            // If debugger slows down execution, corrupt internal state
            // Only active when vmDebugProtection option is enabled (dbgEnabled placeholder)
            //
            // Uses very conservative thresholds to avoid false positives:
            // - 5 second threshold: Normal execution takes < 1ms per 100 instructions
            //   Even under extreme system load, 100 instructions don't take 5 seconds
            // - Only debugger stepping (human clicking "step") causes 5+ second delays
            // - 3 consecutive slow checks required for extra safety
            //
            // False positive analysis:
            // - Normal execution: < 1ms per check → No trigger
            // - Heavy CPU load: 10-100ms per check → No trigger
            // - Extreme GC pause: 100-500ms → No trigger
            // - System thrashing: 500ms-2s → No trigger
            // - Debugger stepping: 1-10+ seconds → TRIGGER
            let _dbgEnabled = {dbgEnabled};
            let _dbgLastTime = 0;
            let _dbgSlowCount = 0;
            let _dbgCorrupted = false;
            let _dbgThreshold = 5000; // 5 seconds - only debugger stepping takes this long
            let _dbgConsecutiveRequired = 3; // 3 consecutive 5+ second delays = definitely debugging
            function _checkDebug() {
                if (!_dbgEnabled || _dbgCorrupted) return;
                let now = Date.now();
                if (_dbgLastTime === 0) {
                    _dbgLastTime = now;
                    return;
                }
                let delta = now - _dbgLastTime;
                _dbgLastTime = now;
                if (delta > _dbgThreshold) {
                    _dbgSlowCount++;
                    if (_dbgSlowCount >= _dbgConsecutiveRequired) {
                        _dbgCorrupted = true;
                        for (let k in {vmOpcodeMapName}) {
                            {vmOpcodeMapName}[k] = ({vmOpcodeMapName}[k] + 1) & ${VMConstants_1.VM_OPCODE_MASK};
                        }
                    }
                } else {
                    _dbgSlowCount = 0;
                }
            }
`;
}
